/* eslint-disable */
import {
    getToken,
    getAdminId,
} from "../../../utils/auth";
// import { $NOT_NETWORK } from '../../utils/errorCode'
import { Message } from "element-ui";
import axios from 'axios'
import https from "../../../utils/http";
let http = https.https
const state = {
};

// getters
const getters = {
};

// mutations
const mutations = {
    
};

// actions
const actions = {
    confirmOneTouchExpenseBill ({ commit }, data) {
        return axios.post(http + '/report/onekeyfee', data).then(res => {
            return res.data
        })
    },
    GetExpenseBillData ({ commit }, data) {
        return axios.post(http + '/report/show_fee', data).then(res => {
            return res.data
        })
    },
    confirmExpenseBill ({ commit }, data) {
        return axios.post(http + '/report/edit_wyfee', data).then(res => {
            return res.data
        })
    },
    ToVoidExpenseBillShow ({ commit }, data) {
        return axios.post(http + '/report/edit_wyfee', data).then(res => {
            return res.data
        })
    },
    ExportExpenseBillData ({ commit }, data) {
        return axios({ method: 'post', url: http + '/report/show_fee', data: data, responseType: 'blob' }).then(res => {
            return res.data
        })
    },
    SavePrint ({ commit }, data) {
        return axios.post(http + '/report/set_bank', data).then(res => {
            return res.data
        })
    },
    OneClickTransmission ({ commit }, data) {
        return axios.post(http + '/Report/send_feeemail', data).then(res => {
            return res.data
        })
    },
    // ExportExpenseBillListShow ({ commit }, data) {
    //     return axios({ method: 'post', url: http + '/expensebill/show', data: data, responseType: 'blob' }).then(res => {
    //         return res.data
    //     })
    // }
};

const ExpenseBillModule = {
    state,
    getters,
    actions,
    mutations
}
export default ExpenseBillModule
